import { computed, defineComponent, toRefs } from '@vue/composition-api';
import DpChart from './Chart.vue';
export default defineComponent({
    name: 'DpAggregateTimelineStrip',
    components: {
        DpChart,
    },
    props: {
        data: { type: Array, default: () => [] },
        fillInconsistentGaps: { type: Boolean, default: false },
        height: { type: String, default: '60px' },
    },
    setup(props) {
        const { data, fillInconsistentGaps } = toRefs(props);
        const chartParams = computed(() => {
            const { value } = data;
            if (!value)
                return null;
            let points = value.map(({ date, text, colour, value: pointValue, }) => ({
                x: date,
                y: pointValue ? pointValue / 100 : 1,
                colour,
                text,
            }));
            // Add manual widths to bars to fill data with inconsitent times
            if (fillInconsistentGaps.value === true) {
                points = points.map((curr, index) => {
                    const next = points[index + 1];
                    if (!next)
                        return curr;
                    const currDate = curr.x;
                    const nextDate = next.x;
                    // Adding an extra 10 seconds to each bar seems to not cause any overlapping and also
                    // fixes any lingering gaps between data
                    const width = nextDate - currDate + 10000;
                    return {
                        ...curr,
                        width,
                    };
                });
            }
            const stripData = {
                values: points,
                hoverinfo: 'x+text',
            };
            const chartData = [stripData];
            const params = {
                yaxis: {
                    zeroline: false,
                    showline: false,
                    autotick: true,
                    ticks: '',
                    showticklabels: false,
                    range: [0, 1],
                },
                yaxis2: {
                    zeroline: false,
                    showline: false,
                    autotick: true,
                    ticks: '',
                    showticklabels: false,
                    range: [0, 100],
                    type: 'linear',
                },
                xaxis: {
                    type: 'date',
                },
                data: chartData,
            };
            return params;
        });
        return {
            chartParams,
        };
    },
});
